import React, { useState, useEffect } from 'react'
import { Row, Col } from 'rsuite'

export default function TargetGroupView(props) {
  const { schema } = props
  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div>
            <p style={{ marginBottom: 10 }}>
              <b>{schema.targetCriteria.label || 'เกณฑ์การคัดเลือก'} :</b>{' '}
              {schema.targetCriteria.value ? schema.targetCriteria.value : '- ไม่ได้ระบุ -'}
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 8 }}>
          <b>แสดงข้อมูลเกณฑ์การคัดเลือกกลุ่มเป้าหมายดำเนินการบริเวณนี้</b>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          {schema.criteriaList.options.map((item, index) => {
            if (schema.criteriaList.optionSelected.some((e) => e === item.value)) {
              return (
                <dl key={index} style={{ marginBottom: 20 }}>
                  <dt style={{ marginLeft: 20, marginBottom: 5 }}>
                    &#9679; {item.text}
                    <span>
                      {' '}
                      {item.numberOfPeople.preText +
                        ' ' +
                        item.numberOfPeople.value +
                        ' ' +
                        item.numberOfPeople.postText}
                    </span>
                  </dt>
                  <dd style={{ marginLeft: 20 }}>
                    <b style={{wordBreak: 'break-all'}}>
                      &#45; {item.detail.text} :{' '}
                      {item.detail.value ? item.detail.value : '- ไม่ได้ระบุ -'}
                    </b>
                  </dd>
                </dl>
              )
            }
          })}
        </Col>
        {schema.criteriaList.optionSelected.length === 0 && (
          <Col xs={24} sm={12} md={8} lg={8}>
            <span> - ไม่ได้ระบุ - </span>
          </Col>
        )}
      </Row>
    </>
  )
}
